function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  rx: 2,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  rx: 2,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_244_33378)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 0H11.4286V1.06667H24V0ZM24 2.13333H11.4286V3.2H24V2.13333ZM11.4286 4.26667H24V5.33334H11.4286V4.26667ZM24 6.4H11.4286V7.46667H24V6.4ZM0 8.53333H24V9.59999H0V8.53333ZM24 10.6667H0V11.7333H24V10.6667ZM0 12.8H24V13.8667H0V12.8ZM24 14.9333H0V16H24V14.9333Z",
  fill: "#E1244A"
}), /*#__PURE__*/React.createElement("rect", {
  width: 13.7143,
  height: 8.53333,
  fill: "#0C3F8E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.71422 7.46665C6.52431 7.46665 7.26879 7.20443 7.85552 6.76596C7.54471 6.87417 7.20829 6.93331 6.85707 6.93331C5.27912 6.93331 3.99993 5.73941 3.99993 4.26665C3.99993 2.79389 5.27912 1.59998 6.85707 1.59998C7.20829 1.59998 7.54471 1.65913 7.85551 1.76733C7.26878 1.32887 6.52431 1.06665 5.71422 1.06665C3.82067 1.06665 2.28564 2.49934 2.28564 4.26665C2.28564 6.03396 3.82067 7.46665 5.71422 7.46665ZM8.15105 6.18872L9.14279 5.14132L10.1345 6.18872L9.87547 4.812L11.3712 4.74136L10.0564 4.07202L10.9298 2.93654L9.5494 3.4786L9.14279 2.13332L8.73618 3.4786L7.35574 2.93654L8.22914 4.07202L6.91438 4.74136L8.4101 4.812L8.15105 6.18872Z",
  fill: "#FFD34F"
}));

function SvgMy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_33378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/MY.0487ba57.svg";
export { ForwardRef as ReactComponent };